import type { CSSProperties } from 'react';

const LETTER_WAVE_INTERVAL_MS = 42;

interface AnimatedLoadingTextProps {
    text: string;
}

function getLetterStyle(index: number) {
    return {
        '--enter-brand-loading-letter-delay': `${index * LETTER_WAVE_INTERVAL_MS}ms`,
    } as CSSProperties;
}

/** 首帧完整显示、随后轻缓起伏的品牌 Loading 文案。 */
export function AnimatedLoadingText({ text }: AnimatedLoadingTextProps) {
    return (
        <span
            aria-label={text}
            className="enter-brand-loading-animated-text"
            data-testid="enter-brand-loading-text"
        >
            {Array.from(text).map((character, index) => (
                <span
                    aria-hidden="true"
                    className="enter-brand-loading-letter"
                    data-enter-brand-loading-letter
                    key={`${character}-${index}`}
                    style={getLetterStyle(index)}
                >
                    <span className="enter-brand-loading-letter-glyph">{character}</span>
                </span>
            ))}
        </span>
    );
}
